module.exports = __webpack_public_path__ + "static/media/office_logos.be340dca.png";